import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { tokenService } from '../services/TokenService';

export function useAuthToken() {
  const { oktaAuth } = useOktaAuth();

  useEffect(() => {
    const updateToken = async () => {
      try {
        const token = await oktaAuth.getAccessToken();
        if (token) {
          tokenService.setToken(token);
        }
      } catch (error) {
        console.error('Failed to get access token:', error);
        tokenService.clearToken();
      }
    };

    updateToken();

    // Set up token refresh
    oktaAuth.authStateManager.subscribe(() => {
      updateToken();
    });

    // No need to unsubscribe as the authStateManager handles cleanup
  }, [oktaAuth]);

  return null;
} 